<!-- edit by wangxuefei -->
<template>
  <div class=''>
    <Modal title="选择地点" width="60%" v-model="show">
      <map-select ref="childnode" :zuobiao="zuobiao"></map-select>
      <div slot="footer">
        <Button type="text" @click="cancel">取消</Button>
        <Button type="primary" @click="confirm">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  import mapSelect from "./map";

  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {mapSelect},
    props: {
      zuobiao: {
        type: Object,
        default: function () {
          return {
            show: true,
            isShowAlert: false
          };
        }
      }
    },
    data() {
      //这里存放数据
      return {
        show: true
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
      zuobiao() {
        /* eslint-disable no-console */
        console.log("-------map-modal---------");
        console.log(this.zuobiao);
      }
    },
    //方法集合
    //方法集合
    methods: {
      confirm() {
        if (this.$refs.childnode.zuobiao.value) {
          this.$refs.childnode.isShowAlert = false
          this.$emit('confirm', this.$refs.childnode.zuobiao)
        } else {
          this.$refs.childnode.isShowAlert = true
        }

      },
      cancel() {
        this.$emit('cancel')
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    } //如果页面有keep-alive缓存功能，这个函数会触发
  };
</script>
<style lang="less" scoped>
  //@import url(); 引入公共css类
</style>
